// @ts-nocheck
import Icon from 'atoms/icons/icon';
import classNames from 'classnames';
import _ from 'lodash';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import CustomizeViewModal from 'organisms/CustomizeViewModal';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ThetaMenu from '../../../organisms/thetaMenu/thetaMenu';
import * as sagaActions from '../sagaActions';
import * as selectors from '../selectors';
import ThetaBulkOrderQtyEditModal from '../thetaBulkOrderQtyEditModal';
import ThetaOrderDeleteModal from '../thetaDeleteOrderModal';
import * as dynamicGridSagaActions from 'models/dynamicGrid/sagaActions';
import ThetaDistributeExcessAvailabilityModal from '../thetaDistributeExcessAvailability';
import ThetaOptimizeShippingMethodModal from '../thetaOptimizeShippingModal';
import ThetaOrderCloneModal from '../thetaOrderCloneModal';
import ThetaSplitOrderModal from '../thetaOrderSplitModal';
import ThetaChangePODateModal from '../thetaPOUpdateModal';
import ThetaOrderPublishModal from '../thetaPublishOrderModal';
import ThetaChangeOrderStatusModal from '../thetaUpdateOrderStatusModal';
import ThetaUpdateShippingMethodModal from '../thetaUpdateShippingMethodModal';
import './actionBar.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import {
	DROPDOWN_MENU_ALL_ORDERS,
	DROPDOWN_MENU_ALL_ORDERS_COMPLETED,
	DROPDOWN_MENU_ORDER_ITEMS,
	DROPDOWN_MENU_ORDER_SKUS,
	DROPDOWN_VALUES,
	MODAL_COLUMNS,
	DROPDOWN_MENU_ORDER_KITS,
} from './constants';
import * as tableColumnSagaActions from 'models/tableColumns/sagaActions';
import * as tableColumnSelectors from 'models/tableColumns/selector';
import ExportGrid from 'organisms/exportGrid';
import { updateModalToggle } from 'organisms/kitsModal/reducer';
import { getDropdownMenu } from './selectors';
import { getOrderFilter } from 'models/dynamicGrid/constants';
import { GRID_EVENTS } from 'molecules/ReactGrid/agGrid/constants';
import { Events } from 'molecules/ReactGrid/agGrid/utils/events';
import { useLocation } from 'react-router-dom';
import { ORDER_DETAILS_TABS } from '../orderDetails/constants';
import { isNewUploadEnabled } from 'models/user/selector';
import GridCsvUpload from 'organisms/uploadData/gridCsvUpload';
import UploadData from 'organisms/uploadData';
import TheataRackingIntegration from '../theataRackingIntegrationModal';
import { Button, Tooltip, Modal } from 'antd';

interface DropdownType {
	displayName: string;
	value: string;
}
interface Props {
	type: 'primary' | 'secondary' | 'tertiary';
	children: React.ReactNode;
	isFilterEnabled: boolean;
	selectedTab: string;
	handleResetViewClick: Function;
	handleUpdateFilter: Function;
	orderStatus: DropdownType;
	gridMeta: TMetadata;
}

const ActionBar: React.FunctionComponent<any> = (props: Props) => {
	const {
		type,
		handleUpdateFilter,
		isFilterEnabled,
		selectedTab,
		handleResetViewClick,
		orderStatus,
		idd,
		setTrigger,
		gridMeta,
		parentTableId,
		onCustomRefresh,
		isBySkuTab,
		onCustomExport,
	} = props;
	const dispatch = useDispatch();
	const openModalName = useSelector((state) => selectors.getOpenModalName(state));
	const filters = useSelector((state) => dynamicGridSelectors.getGridFilters(state, Number(selectedTab)));
	const classes: any = classNames(['actionBar', { [`actionBar--${type}`]: true }]);
	const isNewUpload = useSelector(isNewUploadEnabled);

	const selectedOrders = useSelector((state) =>
		dynamicGridSelectors.getTableSelection(state, Number(selectedTab))
	)?.selectedRowKeys;

	const isSelectAll = useSelector((state) =>
		dynamicGridSelectors.getTableSelection(state, Number(selectedTab))
	)?.isSelectAll;

	const handleClick = React.useCallback(() => {
		handleUpdateFilter(!isFilterEnabled);
	}, [isFilterEnabled]);

	const openModal = (value: string) => {
		dispatch(sagaActions.toggleModalOpen(value));
	};

	const closeModal = (tableIds: any[]) => {
		dispatch(sagaActions.toggleModalClose(tableIds));
	};

	const isCustomizeViewModalEnabled = useSelector((state) => tableColumnSelectors.isCustomizeViewModalEnabled(state));

	const customizeViewHandler = React.useCallback((isCustomizeViewModalEnabled: boolean) => {
		dispatch(tableColumnSagaActions.setCustomizeViewModal(isCustomizeViewModalEnabled));
	}, []);

	const handleMenuItemClick = (value: string) => {
		switch (value) {
			case DROPDOWN_VALUES.LOCK_RECORDS:
				return handleLockUnlockRecordsClick(DROPDOWN_VALUES.LOCK_RECORDS);
			case DROPDOWN_VALUES.UNLOCK_RECORDS:
				return handleLockUnlockRecordsClick(DROPDOWN_VALUES.UNLOCK_RECORDS);
			case DROPDOWN_VALUES.CUSTOMIZE_VIEW:
				return customizeViewHandler(true);
			case DROPDOWN_VALUES.RESET_VIEW:
				return handleResetViewClick();
			case DROPDOWN_VALUES.CREATE_KIT:
				dispatch(
					updateModalToggle({
						isOpen: true,
						isAvailabilityUpdate: false,
						tableId: selectedTab,
					})
				);
				break;
			default:
				return openModal(value);
		}
	};

	/* New Hook for Dirty State */
	const isGridDirty = React.useRef(false);

	React.useEffect(() => {
		const handleDirtyStateChange = ({ tableId, isDirty }) => {
			// Only care about the currently selected tab's table
			if (Number(tableId) === Number(selectedTab)) {
				isGridDirty.current = isDirty;
			}
		};

		const unsubscribe = Events.subscribe(GRID_EVENTS.DIRTY_STATE_CHANGED, handleDirtyStateChange);

		return () => {
			unsubscribe && unsubscribe();
		};
	}, [selectedTab]);

	const handleRefreshClick = () => {
		const triggerRefresh = () => {
			if (onCustomRefresh) {
				onCustomRefresh();
			} else if (idd) {
				setTrigger();
				dispatch(dynamicGridSagaActions.refreshGridData({ tableId: selectedTab }));
			} else {
				dispatch(dynamicGridSagaActions.refreshGridData({ tableId: selectedTab }));
			}
		};

		if (isGridDirty.current) {
			const modal = Modal.confirm({
				title: 'Reload site?',
				content: 'Changes you made may not be saved.',
				okText: 'Reload',
				cancelText: 'Cancel',
				onOk: triggerRefresh,
				centered: true,
				className: 'reload-confirm-modal',
			});

			// Auto-dismiss the modal when dirty state clears (API call completes)
			const unsubDirty = Events.subscribe(GRID_EVENTS.DIRTY_STATE_CHANGED, ({ tableId, isDirty }) => {
				if (Number(tableId) === Number(selectedTab) && !isDirty) {
					modal.destroy();
					unsubDirty && unsubDirty();
				}
			});
		} else {
			triggerRefresh();
		}
	};

	const handleLockUnlockRecordsClick = async (type: string) => {
		let data = {};
		if (type === DROPDOWN_VALUES.LOCK_RECORDS) {
			data = {
				IsReadOnly: true,
				OrderIDs: selectedOrders.join(','),
				isSelectAll,
			};
			dispatch(sagaActions.lockUnlockRecords({ selectedTab, data }));
		} else {
			data = {
				IsReadOnly: false,
				OrderIDs: selectedOrders.join(','),
				isSelectAll,
			};
			dispatch(sagaActions.lockUnlockRecords({ selectedTab, data }));
		}
	};

	const dropdownMenu = useSelector((state) => getDropdownMenu(state, selectedTab, orderStatus, isBySkuTab));

	const isRackingEnabled = useSelector((state) => dynamicGridSelectors.getERPStatus(state, 116));

	const hideCustomizeViewModal = React.useCallback(() => {
		customizeViewHandler(false);
	}, []);

	const getDisabledStatus = (option) => {
		switch (option.value) {
			case DROPDOWN_VALUES.CUSTOMIZE_VIEW:
				return false;
			case DROPDOWN_VALUES.RESET_VIEW:
				return false;
			case DROPDOWN_VALUES.RACKING_INTEGRATION:
				return !isRackingEnabled || !selectedOrders?.length;
			default:
				return !selectedOrders?.length && !isSelectAll;
		}
	};

	return (
		<div className={classes}>
			<Stack position="bottom" align="right" gutter="large" className="action-btns">
				{isNewUpload && gridMeta?.UploadTableID && (
					<StackItem className="action-btn">
						<GridCsvUpload uploadTableId={gridMeta?.UploadTableID} parentTableId={parentTableId} />
					</StackItem>
				)}
				<StackItem className="action-btn">
					<Tooltip title="Refresh">
						{' '}
						<Button
							className="menu-action--button"
							icon={<FontAwesomeIcon className="font-icon" isActive icon={faArrowsRotate} />}
							onClick={handleRefreshClick}
						/>
					</Tooltip>
				</StackItem>

				<StackItem className="action-btn">
					{isBySkuTab && onCustomExport ? (
						<Tooltip title="Export Data (CSV)">
							<Button
								className="menu-action--button"
								type="primary"
								icon={<i className="icon-import" />}
								onClick={() => {
									const name = window.prompt('Enter a name for this export:', 'OrderBySKU_Export');
									if (name) onCustomExport(name);
								}}
							/>
						</Tooltip>
					) : (
						<ExportGrid key={selectedTab} tableId={selectedTab} />
					)}
				</StackItem>
				<StackItem className="action-btn">
					<Tooltip title="More Options">
						{' '}
						<ThetaMenu
							type="3Dots"
							options={dropdownMenu.filter((x) => x.value !== DROPDOWN_VALUES.CUSTOMIZE_VIEW)}
							handleItemClick={handleMenuItemClick}
							isDisabled={getDisabledStatus}
						/>
					</Tooltip>
				</StackItem>
			</Stack>
			{openModalName === DROPDOWN_VALUES.CLONE_ORDERS && (
				<ThetaOrderCloneModal
					hideModal={() => closeModal(MODAL_COLUMNS.ORDER_CLONE)}
					selectedTab={selectedTab}
				/>
			)}
			{openModalName === DROPDOWN_VALUES.SPLIT_ORDERS && (
				<ThetaSplitOrderModal
					hideModal={() => closeModal(MODAL_COLUMNS.SPLIT_COLUMNS)}
					selectedTab={selectedTab}
				/>
			)}
			{openModalName === DROPDOWN_VALUES.DELETE_ORDERS && (
				<ThetaOrderDeleteModal hideModal={() => closeModal([])} selectedTab={selectedTab} />
			)}
			{openModalName === DROPDOWN_VALUES.UPDATE_SHIPPING_METHOD && (
				<ThetaUpdateShippingMethodModal hideModal={() => closeModal([])} selectedTab={selectedTab} />
			)}
			{openModalName === DROPDOWN_VALUES.CHANGE_PO_DATE && (
				<ThetaChangePODateModal hideModal={() => closeModal([])} selectedTab={selectedTab} />
			)}
			{openModalName === DROPDOWN_VALUES.PUBISH_ORDERS && (
				<ThetaOrderPublishModal hideModal={() => closeModal([])} selectedTab={selectedTab} />
			)}
			{openModalName === DROPDOWN_VALUES.UPDATE_ORDER_STATUS && (
				<ThetaChangeOrderStatusModal hideModal={() => closeModal([])} selectedTab={selectedTab} />
			)}
			{openModalName === DROPDOWN_VALUES.OPTIMIZE_SHIPPING_METHOD && (
				<ThetaOptimizeShippingMethodModal
					hideModal={() => closeModal(MODAL_COLUMNS.OPTIMIZE)}
					selectedTab={selectedTab}
				/>
			)}
			{openModalName === DROPDOWN_VALUES.DISTRIBUTE_EXCESS_AVAIL && (
				<ThetaDistributeExcessAvailabilityModal
					hideModal={() => closeModal(MODAL_COLUMNS.DISTRIBUTE)}
					selectedTab={selectedTab}
				/>
			)}
			{isCustomizeViewModalEnabled && (
				<CustomizeViewModal hideModal={hideCustomizeViewModal} tableId={Number(selectedTab)} />
			)}
			{openModalName === DROPDOWN_VALUES.BULK_ORDER_QTY_EDIT && (
				<ThetaBulkOrderQtyEditModal hideModal={() => closeModal([])} selectedTab={selectedTab} />
			)}
			{openModalName === DROPDOWN_VALUES.RACKING_INTEGRATION && (
				<TheataRackingIntegration hideModal={() => closeModal([])} selectedTab={selectedTab} />
			)}
		</div>
	);
};

ActionBar.defaultProps = {
	type: 'primary',
};

export default ActionBar;
